export default {
  data() {
    const issuerBankSchema = [
      {
        label: 'Bank Name',
        type: 'input',
        key: 'bankName',
      },
      {
        label: 'Reference Number',
        type: 'input',
        key: 'referenceNumber',
      },
    ]
    return {
      issuerBankSchema,
    }
  },
}
